import React, { useRef } from 'react';
import { AvForm, AvGroup, AvField, AvInput } from 'availity-reactstrap-validation';
import { Button, Row, Col, Label } from 'reactstrap';
import Multiselect from 'multiselect-react-dropdown';
import { Audit } from '../../../../../_metronic/helpers/components/Audit';
import { Content } from '../../../../../_metronic/helpers/components/Content';
import InfoRow from './InfoRow';

const ProductGeneralSection = ({ 
    product, 
    intl, 
    validation, 
    categories, 
    optionValues, 
    productTypes, 
    suppliers, 
    onSubmit,
    isEditing
}) => {
    
    const supplierDropdown = useRef();

    const getSelectedItems = (list, ids) => {
        if (!list || !ids) return [];
        return list.filter((item) => ids.find(s => s == item.id));
    }
    
    const getSelectedSupplierNames = () => {
        if (!suppliers || !product.supplierIds) return '';
        return suppliers.filter(s => product.supplierIds.includes(s.id)).map(s => s.name).join(', ');
    }

    const handleValidSubmit = (event, values) => {
        values = {
            ...values,
            supplierIds: supplierDropdown.current.getSelectedItems().map(s => s.id),
        };
        onSubmit(event, values);
    }

    if (!isEditing) {
        return (
            <div className='card mb-5 mb-xl-10 shadow-sm'>
                <div className="card-header cursor-pointer">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">{intl.formatMessage({ id: 'PRODUCT.DETAIL.TITLE' })}</h3>
                    </div>
                    <div className="card-toolbar">
                        <Audit table="Product" identifier={product.id} />
                    </div>
                </div>
                <div className="card-body p-9">
                     <div className='row mb-7'>
                        <div className='col-lg-6'>
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.NAME' })} value={product.name} />
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.SKU' })} value={product.sku} />
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.ENABLED' })} value={product.isActive ? 'Yes' : 'No'} />
                             <div className='row mb-3'>
                                <label className="col-lg-4 fw-bold text-muted fs-6">{intl.formatMessage({ id: 'PRODUCT.FIELD.DESCRIPTION' })}</label>
                                <div className="col-lg-8">
                                    <span className="fw-bolder fs-6 text-gray-800">{product.description}</span>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.CATEGORY' })} value={product.category ? product.category.name : categories && categories.find(c => c.id === product.categoryId)?.name} />
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.TYPE' })} value={productTypes && productTypes.find(t => t.value === product.type)?.name || product.type} />
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.COLOR' })} value={product.optionValue ? product.optionValue.name : optionValues && optionValues.find(o => o.id === product.optionValueId)?.name} />
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.WEIGHT' })} value={`${product.weight} ${product.weightUnit}`} />
                            <InfoRow label={intl.formatMessage({ id: 'PRODUCT.FIELD.SUPPLIERS' })} value={getSelectedSupplierNames()} />
                        </div>
                     </div>
                </div>
            </div>
        )
    }

    return (
        <div className='card mb-5 mb-xl-10 shadow-sm'>
             <div className="card-header cursor-pointer">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{intl.formatMessage({ id: 'PRODUCT.DETAIL.EDITPRODUCT' })}</h3>
                </div>
                <div className="card-toolbar">
                    <Audit table="Product" identifier={product.id} />
                </div>
            </div>
            <div className="card-body p-9">
                <AvForm key={1} onValidSubmit={handleValidSubmit}>
                    
                    <div className="mb-10">
                         <div className='row g-5'>
                            <div className='col-lg-8'>
                                <AvGroup>
                                    <Label className="fs-6 fw-bold mb-2 required">{intl.formatMessage({ id: 'PRODUCT.FIELD.NAME' })} <Content table="Product" identifier={product.id} field={"Name"} /></Label>
                                    <AvInput name="name" value={product && product.name} validate={validation} className="form-control form-control-solid" />
                                </AvGroup>
                            </div>
                            <div className='col-lg-4'>
                                <AvField name="sku" label={intl.formatMessage({ id: 'PRODUCT.FIELD.SKU' })} type="text" value={product && product.sku} validate={validation} className="form-control form-control-solid" />
                            </div>
                            <div className='col-lg-12'>
                                <AvGroup>
                                    <Label className="fs-6 fw-bold mb-2">{intl.formatMessage({ id: 'PRODUCT.FIELD.DESCRIPTION' })} <Content table="Product" identifier={product.id} field={"Description"} /></Label>
                                    <AvInput type="textarea" name="description" value={product && product.description} validate={validation} className="form-control form-control-solid" rows="3" />
                                </AvGroup>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-check form-check-custom form-check-solid">
                                    <AvField type="checkbox" key={product ? product.id : 'default'} name="isActive" value={product && product.isActive} className="form-check-input" id="isActiveProduct" />
                                    <label className="form-check-label fw-bold ps-2" htmlFor="isActiveProduct">{intl.formatMessage({ id: 'PRODUCT.FIELD.ENABLED' })}</label>
                                </div>
                            </div>
                         </div>
                    </div>

                    <div className="separator separator-dashed my-10"></div>

                    <div className="mb-10">
                        <div className="row g-5">
                            <div className='col-lg-4'>
                                <AvField type="select" name="categoryId" label={intl.formatMessage({ id: 'PRODUCT.FIELD.CATEGORY' })} validate={validation} value={product && product.categoryId} className="form-select form-select-solid">
                                    <option value=''>{intl.formatMessage({ id: 'GENERAL.SELECT' })}</option>
                                    {categories && categories.map((item, index) => {
                                        return (
                                            <option key={`categories_${index}`} value={item.id}>{item.name}</option>
                                        )
                                    })}
                                </AvField>
                            </div>
                            <div className='col-lg-4'>
                                 <AvField type="select" name="type" label={intl.formatMessage({ id: 'PRODUCT.FIELD.TYPE' })} validate={validation} value={product && product.type} className="form-select form-select-solid">
                                    <option value=''>{intl.formatMessage({ id: 'GENERAL.SELECT' })}</option>
                                    {productTypes && productTypes.map((item, index) => {
                                        return (
                                            <option key={`producttype_${index}`} value={item.value}>{item.name}</option>
                                        )
                                    })}
                                </AvField>
                            </div>
                             <div className='col-lg-4'>
                                <AvField type="select" name="optionValueId" label={intl.formatMessage({ id: 'PRODUCT.FIELD.COLOR' })} validate={validation} value={product && product.optionValueId} className="form-select form-select-solid">
                                    <option value=''>{intl.formatMessage({ id: 'GENERAL.SELECT' })}</option>
                                    {optionValues && optionValues.map((item, index) => {
                                        return (
                                            <option key={`optionvalue_${index}`} value={item.id}>{item.name}</option>
                                        )
                                    })}
                                </AvField>
                            </div>
                            <div className='col-lg-6'>
                                <div className='fv-row'>
                                    <label className='form-label fs-6 fw-bold'>{intl.formatMessage({ id: 'PRODUCT.FIELD.SUPPLIERS' })}</label>
                                    <Multiselect name="supplierIds" ref={supplierDropdown}
                                        options={suppliers}
                                        selectedValues={getSelectedItems(suppliers, product.supplierIds)}
                                        displayValue="name"
                                        isObject={true}
                                        style={{
                                            chips: { background: '#009ef7' },
                                            searchBox: { border: 'none', background: '#f5f8fa' }, // Matching form-control-solid
                                            multiselectContainer: { color: 'inherit' }
                                        }}
                                        className="form-control form-control-solid p-0" // wrapper class
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="separator separator-dashed my-10"></div>

                     <div className="mb-10">
                        <div className="row g-5">
                            <div className='col-lg-3'>
                                <AvField name="weight" label={intl.formatMessage({ id: 'PRODUCT.FIELD.WEIGHT' })} type="number" value={product && product.weight} validate={validation} className="form-control form-control-solid" />
                            </div>
                            <div className='col-lg-3'>
                                <AvField type="select" name="weightUnit" label={intl.formatMessage({ id: 'PRODUCT.FIELD.UNIT' })} validate={validation} value={product && product.weightUnit} className="form-select form-select-solid">
                                    <option value=''>{intl.formatMessage({ id: 'GENERAL.SELECT' })}</option>
                                    <option value='g'>Gram</option>
                                    <option value='kg'>Kilogram</option>
                                    <option value='t'>Ton</option>
                                </AvField>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex justify-content-end'>
                        <AvField type="hidden" name="id" value={product && product.id} />
                        <Button color="primary" type="submit" className="btn-active-light-primary">{intl.formatMessage({ id: 'GENERAL.SUBMIT' })}</Button>
                    </div>
                </AvForm>
            </div>
        </div>
    );
};

export default ProductGeneralSection;
